// Mirrors Crm::SalesUnit::FLOW_SCHEMA. Each role path points at an array of
// employee codes inside build_up_flow / hot_roll_flow. Engineering is split per
// stage (quotation vs enter job) — reading engineering.design_incharge directly
// returns nothing on current data.
export const FLOW_TYPES = [
  { key: 'build_up_flow', label: 'Build up' },
  { key: 'hot_roll_flow', label: 'Hot roll' },
];

export const FLOW_SECTIONS = [
  {
    key: 'eng_quotation',
    label: 'Engineering · Quotation',
    roles: [
      { label: 'Designer', path: ['engineering', 'quotation', 'design_incharge'] },
      { label: 'Detailer', path: ['engineering', 'quotation', 'detailer_incharge'] },
      { label: 'Manager', path: ['engineering', 'quotation', 'manager'] },
    ],
  },
  {
    key: 'eng_enter_job',
    label: 'Engineering · Enter job',
    roles: [
      { label: 'Designer', path: ['engineering', 'enter_job', 'design_incharge'] },
      { label: 'Detailer', path: ['engineering', 'enter_job', 'detailer_incharge'] },
      { label: 'Manager', path: ['engineering', 'enter_job', 'manager'] },
    ],
  },
  {
    key: 'csd',
    label: 'CSD',
    roles: [
      { label: 'Order entry', path: ['csd', 'order_entry'] },
      { label: 'Order management', path: ['csd', 'order_management'] },
      { label: 'Contract management', path: ['csd', 'contract_management'] },
      { label: 'GM Operation', path: ['csd', 'general_manager_operation'] },
    ],
  },
  {
    key: 'finance',
    label: 'Finance',
    roles: [
      { label: 'Credit controller', path: ['finance', 'credit_controller'] },
      { label: 'Finance controller', path: ['finance', 'finance_controller'] },
    ],
  },
  {
    key: 'factory',
    label: 'Factory',
    roles: [
      { label: 'Contract', path: ['factory', 'contract'] },
      { label: 'Estimate forecast', path: ['factory', 'estimate_forecast'] },
      { label: 'Waiver', path: ['factory', 'waiver'] },
      { label: 'A/B Erection', path: ['factory', 'ab_erection'] },
    ],
  },
];

export const roleKey = (path) => path.join('.');

export const getCodes = (flow, path) => {
  const value = path.reduce((acc, key) => (acc && typeof acc === 'object' ? acc[key] : undefined), flow);
  return Array.isArray(value) ? value.flat().filter(Boolean) : [];
};

// Immutable deep set: returns a new flow with `codes` at `path`.
export const setCodes = (flow, path, codes) => {
  const [head, ...rest] = path;
  const current = flow && typeof flow === 'object' ? flow : {};
  return {
    ...current,
    [head]: rest.length === 0 ? codes : setCodes(current[head], rest, codes),
  };
};

// Full, schema-shaped copy so the editor always submits every role.
export const normalizeFlow = (flow) =>
  FLOW_SECTIONS.flatMap((section) => section.roles).reduce(
    (acc, role) => setCodes(acc, role.path, getCodes(flow, role.path)),
    {}
  );
